import * as React from 'react';
import EfNavPage from '@elem/ui/ef-nav-page';
import { useRouter } from 'next/router';
import { formatPointsByLocale, injectNotes } from 'lowcomp/plugins/member/utils';
import { getIsLogin } from '@/utils/cookie';
// import { Fragment } from 'react';
import EditorLink from 'lowcode/components/EditorLink';
import './index.scss';
import style from './styles.module.scss';
import getLocal from '@/app/utils/getLocal';
import { getLang } from 'lowcomp/plugins/member/utils';
import { TextLang } from 'lowcode/OldMember/TextLang';
import { textLang } from 'lowcomp/plugins/member/common/textLang';
import { useEcoStore } from 'lowcode/utils/context/ecocredits';
import EFArrowRightUp from '@/components/UI/svg/Icons/EFArrowRightUp';
import { JoinEcoclubIcon } from '@/components/EcoCredits/Svg';
import { Progress } from 'antd-v5';
import FullScreenModal from 'lowcomp/plugins/member/common/FullScreenModal';
import RewardsRedeemed from 'lowcomp/plugins/member/common/RewardsRedeemed';
import PointsActivity from 'lowcode/OldMember/JoinEcoclubNew/PointsActivity';
import GrabEcoCreditsBonus from 'lowcode/OldMember/JoinEcoclubNew/GrabEcoCreditsBonus';
import { useMemberTimeStore } from 'lowcode/utils/context/memberTimeZone';
import { getDiscountCouponList, getIssuedCoupons, getLevelLogList, getRewardHistory, getRewardsActivity, getDiscountCouponListNew1 } from '@/service/vip';
import { FormatMoney } from '@/utils';

export default function Content({ id, data, initIndex = 0, isEditStatus = false, refershData }: any) {
    const { list = [], bgColor, textColor, textActiveColor, textActiveBgColor } = data;
    const { locale } = getLocal();
    const t = getLang(TextLang, locale);
    const tModal = getLang(textLang, locale);
    const { rewardUserInfo, rewardUserLevel } = useEcoStore();
    const { timezoneList } = useMemberTimeStore();

    const [showPage, setShowPage] = React.useState('basic');
    const [issuedCoupon, setIssuedCoupon] = React.useState<any[]>([]);
    const [pointsActivity, setPointsActivity] = React.useState([]);
    const [rewardsActivity, setRewardsActivity] = React.useState([]);
    const [levelLogList, setLevelLogList] = React.useState<any[]>([]);
    const [discountCouponList, setDiscountCouponList] = React.useState<any[]>([]);
    const [firstIn, setFirstIn] = React.useState(true);

    const openModal = (key: string) => {
        setShowPage(key);
    };

    const closeModal = () => {
        setShowPage('basic');
    };

    /**
     * 查询issued优惠券兑换记录
     */
    const queryIssuedRewards = async () => {
        let rewardRedeemRules = [];
        const res = await getIssuedCoupons(locale as string);

        if (res?.code === '0') {
            const flatRules = res.data?.map((item: any) => {
                let minimum_rule = '';
                if (item?.prerequisite === 'PRICES') {
                    // 最低金额
                    const price = parseInt(item.prerequisiteRange);
                    const currencySymbol = item?.ruleWebsite?.currencySymbol || '';
                    const prerequisiteRange = tModal('minimum_price', { price: currencySymbol + FormatMoney(price) });
                    minimum_rule = prerequisiteRange;
                }
                if (item?.prerequisite === 'QUANTITY') {
                    // 最低数量
                    const num = parseInt(item.prerequisiteRange);
                    const prerequisiteRange = tModal('minimum_num', { num });
                    minimum_rule = prerequisiteRange;
                }
                return {
                    ...item,
                    minimum_rule,
                };
            });

            rewardRedeemRules = injectNotes(flatRules || [], tModal, locale as string, timezoneList);
            setIssuedCoupon(rewardRedeemRules || []);
        }
    };

    /**
     * 查询查询Rewards Activity 优惠券使用流水
     */
    const queryRewardsActivity = async () => {
        const res = await getRewardsActivity(locale as string);
        if (res?.code === '0') {
            setRewardsActivity(res.data?.content || []);
        }
    };

    /**
     * 用户积分历史记录
     */
    const queryRewardHistory = async (sortType?: number) => {
        const res = await getRewardHistory(locale as string, sortType);
        if (res?.code === '0') {
            setPointsActivity(res.data?.content || []);
        }
    };

    /**
     * 查询查询升级日志
     */
    const queryLevelLogList = async () => {
        const res = await getLevelLogList(locale as string);
        if (res?.code === '0') {
            setLevelLogList(res.data || []);
        }
    };

    console.log({ rewardUserInfo });
    const items: { title: any; href: string }[] = [];
    const { asPath = '' } = useRouter();
    const [isLogin, setIsLogin] = React.useState(false);

    /**
     * 福利中心
     */
    const queryDiscountCouponList = async () => {
        const apiRequestFn = !isLogin ? getDiscountCouponListNew1 : getDiscountCouponList;
        const res = await apiRequestFn(locale as string);
        if (res?.code === '0') {
            const coupons = injectNotes(res.data, tModal, locale as string, timezoneList);
            setDiscountCouponList(coupons || []);
            const isHasUnUsedCoupons = coupons?.some((coupon: any) => coupon?.receiveStatus === 1 || !coupon?.receiveStatus);
            firstIn && isHasUnUsedCoupons && setShowPage('bouns_modal');
            setFirstIn(false);
        }
    };

    let initIndex2 = isEditStatus ? initIndex : 0;
    list.forEach((item: any, indexA: number) => {
        if (item.title) {
            if (item.hrefType === 'other') {
                //其它外链
                if (item.hrefOut) {
                    items.push({
                        title: item.title,
                        href: item.hrefOut,
                    });
                }
            } else if (item.href) {
                //本页面ID
                items.push({
                    title: item.title,
                    href: `#${item.href}`,
                });
            }
        }
    });
    items.forEach((item: any, indexA: number) => {
        if (asPath.includes(item.href)) {
            initIndex2 = indexA;
        }
    });

    React.useEffect(() => {
        const login = getIsLogin();
        setIsLogin(login);
    }, []);

    return (
        <React.Fragment>
            <EfNavPage
                items={items}
                bgColor={bgColor}
                textColor={textColor}
                textActiveColor={textActiveColor}
                textActiveBgColor={textActiveBgColor}
                className="editor-temp temp-member-page-nav"
                initIndex={initIndex2}
                isEditStatus={isEditStatus}
            />
            {showPage === 'coupon_modal' && (
                <FullScreenModal
                    visible={showPage === 'coupon_modal'}
                    className={showPage}
                    style={{ background: '#f8f8f8' }}
                    closeModal={closeModal}
                    afterOpen={() => {
                        queryIssuedRewards();
                    }}
                >
                    <RewardsRedeemed modal defaultSelectKey={(showPage?.includes('$') && showPage?.split('$').pop()) || '1'} issuedCoupon={issuedCoupon} />
                </FullScreenModal>
            )}
            {showPage === 'history_modal' && (
                <FullScreenModal
                    visible={showPage === 'history_modal'}
                    className={showPage}
                    closeModal={closeModal}
                    afterOpen={() => {
                        queryRewardsActivity();
                        queryRewardHistory();
                        queryLevelLogList();
                    }}
                >
                    <PointsActivity
                        modal
                        pointsActivity={pointsActivity}
                        rewardsActivity={rewardsActivity}
                        levelLogList={levelLogList}
                        locale={locale}
                        handleSortChange={queryRewardHistory}
                    />
                </FullScreenModal>
            )}
            <FullScreenModal
                visible={showPage === 'bouns_modal'}
                zIndex={1200}
                className={`${showPage} top bouns_modal`}
                closeModal={closeModal}
                style={{ background: '#f5f5f5' }}
                afterOpen={() => {
                    queryDiscountCouponList();
                }}
            >
                <GrabEcoCreditsBonus
                    coupons={discountCouponList}
                    setShowPage={setShowPage}
                    isNeedValidate={true}
                    visible={showPage === 'bouns_modal'}
                    refershData={() => {
                        refershData && refershData();
                        queryDiscountCouponList();
                    }}
                />
            </FullScreenModal>
        </React.Fragment>
    );
}
